import * as moment from 'moment';
import { Moment } from 'moment';
import { DateRangePickerValue } from '../components/date-range-picker/date-range-picker.component';

export const API_DAY_FORMAT = 'YYYY-MM-DD';
export const API_ISO_DAY_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';

export class DateUtils {
  static datesForPeriod(period: DateRangePickerValue): Moment[] {
    const { start, end } = period.end.isBefore(period.start)
      ? { start: period.end.clone(), end: period.start.clone() }
      : { end: period.end.clone(), start: period.start.clone() };

    const dates: Moment[] = [];
    const date = start.clone();

    while (date.isBefore(end)) {
      dates.push(date.clone());
      date.add(1, 'day');
    }

    return dates;
  }

  static datesInMonth(monthDate: Date): Date[] {
    const month = moment(monthDate);
    const interval = {
      start: month.clone().startOf('month'),
      end: month.clone().endOf('month'),
    };

    return DateUtils.datesForPeriod(interval).map((m) => m.toDate());
  }
}
